// Lightweight wrappers around the existing PostHog integration (loaded in index.html).
// No new tracking library, no PII sent — only non-identifying conversion + referral events.

const AI_SOURCES = [
  { match: /chatgpt\.com|chat\.openai\.com/i, source: 'chatgpt' },
  { match: /perplexity\.ai/i, source: 'perplexity' },
  { match: /gemini\.google\.com|bard\.google\.com/i, source: 'gemini' },
  { match: /copilot\.microsoft\.com|bing\.com\/chat/i, source: 'copilot' },
  { match: /\.bing\.com|^https?:\/\/bing\.com/i, source: 'bing' },
  { match: /duckduckgo\.com/i, source: 'duckduckgo' },
];

export const track = (event, props = {}) => {
  try {
    if (typeof window !== 'undefined' && window.posthog) {
      window.posthog.capture(event, props);
    }
  } catch (_) {
    /* analytics must never break the app */
  }
};

// Detect referrals coming from AI search / assistants and tag the session.
export const detectReferralSource = () => {
  try {
    const ref = typeof document !== 'undefined' ? document.referrer : '';
    if (!ref) return;
    const host = new URL(ref).host;
    if (typeof window !== 'undefined' && host === window.location.host) return;
    const hit = AI_SOURCES.find((s) => s.match.test(ref));
    if (hit && window.posthog) {
      window.posthog.register({ ai_source: hit.source });
      track('ai_referral', { ai_source: hit.source, referrer_host: host });
    }
  } catch (_) {
    /* ignore malformed referrer */
  }
};
